import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_MARK } from "@/lib/brand";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const BrandLogo = ({ className = "", markClass = "h-9 w-9", dark = false }) => (
  <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <img src={LOGO_MARK} alt="TradeOff by Blue Shuck" className={`${markClass} object-contain`} />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-xl font-bold tracking-tight ${dark ? "text-white" : "text-navy"}`}>
        TradeOff
      </span>
      <span className={`text-[10px] font-medium tracking-wide mt-0.5 ${dark ? "text-slate-400" : "text-slate-500"}`}>
        by Blue Shuck
      </span>
    </span>
  </Link>
);

const MarketingNav = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <BrandLogo />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600">
          <a href="/#features" className="hover:text-blue-600 transition-colors" data-testid="nav-features">Features</a>
          <a href="/#workflow" className="hover:text-blue-600 transition-colors" data-testid="nav-workflow">Workflow</a>
          <Link to="/roi" className="hover:text-blue-600 transition-colors" data-testid="nav-roi">ROI Calculator</Link>
          <Link to="/pricing" className="hover:text-blue-600 transition-colors" data-testid="nav-pricing">Pricing</Link>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <Button onClick={() => navigate("/app")} data-testid="nav-dashboard-btn" className="bg-blue-600 hover:bg-blue-700">
              Open App
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn" className="hidden sm:inline-flex text-slate-700">
                Log in
              </Button>
              <Button onClick={() => navigate("/register")} data-testid="nav-signup-btn" className="bg-blue-600 hover:bg-blue-700">
                Start free
              </Button>
            </>
          )}
          <button
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="md:hidden ml-1 text-slate-600 hover:text-slate-900"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-3 space-y-1" data-testid="mobile-menu-panel">
          <a href="/#features" onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">Features</a>
          <a href="/#workflow" onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">Workflow</a>
          <Link to="/roi" onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium" data-testid="mobile-nav-roi">ROI Calculator</Link>
          <Link to="/pricing" onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">Pricing</Link>
          {!user && (
            <Link to="/login" onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">Log in</Link>
          )}
        </div>
      )}
    </header>
  );
};

export default MarketingNav;
